export default __webpack_public_path__ + "static/media/othergoals.77c200a8.png";